import { Modal } from "react-bootstrap";
import ReactDOM from "react-dom/client";
import i18n from "./language/INEXT";
import { Box, ButtonStyled, SpanStyled } from "./components/styled/Elements";
import { PdfIcon } from "./components/styled/AllImages";
// import * as XLSX from "xlsx";

export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const phoneRegex = /^(?:966|0)?5\d{8}$/;
// export const phoneRegex = /^(009665|9665|\+9665|05|5)([503649187])([0-9]{7})$/;

export const getAccessToken = () => {
  const storedToken = localStorage.getItem("access_token");
  const accessToken = JSON.parse(storedToken);
  return accessToken;
};

export const getUserObj = () => {
  const storedUser = localStorage.getItem("userInfo");
  const userToken = JSON.parse(storedUser);
  return userToken;
};
export const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
export const getFormattedDate = (isoDate) => {
  const date = new Date(isoDate);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear().toString().slice(-2);
  return `${month}/${day}/${year}`;
};
export const reqFormatDate = (isoDate) => {
  const date = new Date(isoDate);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear().toString().slice(-2);
  return `${year}-${month}-${day}`;
};

export const getFormattedTime = (isoDate) => {
  const date = new Date(isoDate);
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${hours}:${minutes} ${ampm}`;
};
export const getFormattedTimeWithSec = (isoDate) => {
  const date = new Date(isoDate);
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${hours}:${minutes}:${seconds} ${ampm}`;
};
export const formatedRemainingTime = (seconds) => {
  if (seconds < 60) {
    return `${Math.ceil(seconds)} sec${seconds > 1 ? "s" : ""}`;
  } else if (seconds < 3600) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.ceil(seconds % 60);
    return `${minutes} min${minutes > 1 ? "s" : ""} ${remainingSeconds} sec${
      remainingSeconds > 1 ? "s" : ""
    }`;
  } else {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${hours} hr${hours > 1 ? "s" : ""} ${minutes} min${
      minutes > 1 ? "s" : ""
    }`;
  }
};
export const formateAmounts = (num) => {
  var parsedNum = parseFloat(num);
  var formattedNum = parsedNum.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formattedNum ? formattedNum : 0;
};

export const formatTimeToFull = (dateObj) => {
  if (!(dateObj instanceof Date) || isNaN(dateObj)) return "00:00:00";

  const pad = (val) => String(val).padStart(2, "0");
  const hours = pad(dateObj.getHours());
  const minutes = pad(dateObj.getMinutes());
  const seconds = pad(dateObj.getSeconds());

  return `${hours}:${minutes}:${seconds}`;
};

export const formatToUTF = (dateStr) => {
  const date = new Date(dateStr);
  return date;
};

export const checkPermission = (moduleId, actionId) => {
  const userObj = getUserObj();
  const permissions = userObj?.permissions;
  const userType = Number(userObj?.user_type_id);

  if (userType === 2 || userObj?.is_temporary_admin_director) {
    return true;
  } else if (
    permissions &&
    Array.isArray(permissions) &&
    permissions.length > 0
  )
    return permissions.some(
      (permission) =>
        parseInt(permission.permission_type_id) === parseInt(moduleId) &&
        parseInt(permission.permission_operation_id) === parseInt(actionId)
    );
  else return false;
};

export const getModuleOperations = (typeId, actionId) => {
  const userObj = getUserObj();
  const userType = Number(userObj?.user_type_id);
  const permissions = userObj?.permissions;

  if (userType === 2 || userObj?.is_temporary_admin_director) {
    return true;
  } else if (
    permissions &&
    Array.isArray(permissions) &&
    permissions.length > 0
  ) {
    const moduleOperations = permissions
      .filter((permission) => parseInt(permission.permission_type_id) === parseInt(typeId))
      .map((permission) => parseInt(permission.permission_operation_id));
    return moduleOperations.includes(actionId);
  }
  return false;
};

export const showSessionExpiredModal = () => {
  const modalContainer = document.createElement("div");
  document.body.appendChild(modalContainer);

  const handleSessionReset = () => {
    window.location.href = "/login";
  };

  const root = ReactDOM.createRoot(modalContainer); // ✅ React 18+
  root.render(
    <Modal show={true} centered size="sm" backdrop="static" keyboard={false}>
      <Modal.Body className="text-center px-4 pt-4 pb-2">
        <SpanStyled color="var(--text)">
          {i18n.t("session_expired_login_again")}
        </SpanStyled>
        <Box className="d-flex justify-content-center">
          <ButtonStyled
            label={i18n.t("ok")}
            bg={"var(--white)"}
            color={"var(--themeColor)"}
            onClick={handleSessionReset}
          />
        </Box>
      </Modal.Body>
    </Modal>
  );
};

// export const showSessionExpiredModal = () => {
//   const modalContainer = document.createElement("div");
//   document.body.appendChild(modalContainer);

//   const handleSessionReset = () => {
//     // localStorage.clear();
//     window.location.href = "/login";
//   };

//   ReactDOM.render(
//     <Modal show={true} centered size="sm">
//       <Modal.Body className="text-center px-4 pt-4 pb-2">
//         <SpanStyled color="var(--text)">
//           {i18n.t("session_expired_login_again")}
//         </SpanStyled>
//         <Box className="d-flex justify-content-center">
//           <ButtonStyled
//             label={i18n.t("ok")}
//             bg={"var(--white)"}
//             color={"var(--themeColor)"}
//             onClick={handleSessionReset}
//           />
//         </Box>
//       </Modal.Body>
//     </Modal>,
//     modalContainer
//   );
// };

// Excel File Import Method

// export const readExcelFile = (file) => {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();

//     reader.onload = (e) => {
//       const data = new Uint8Array(e.target.result);
//       const workbook = XLSX.read(data, { type: "array" });

//       const sheetName = workbook.SheetNames[0];
//       const worksheet = workbook.Sheets[sheetName];
//       const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

//       resolve(jsonData);
//     };

//     reader.onerror = (error) => reject(error);
//     reader.readAsArrayBuffer(file);
//   });
// };

export function getRemainingParts(endTime) {
  const now = new Date();
  const end = new Date(endTime);

  let diff = end - now;
  if (diff <= 0)
    return { days: "00", hours: "00", minutes: "00", seconds: "00" };

  const days = String(Math.floor(diff / (1000 * 60 * 60 * 24))).padStart(
    2,
    "0"
  );
  diff %= 1000 * 60 * 60 * 24;

  const hours = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, "0");
  diff %= 1000 * 60 * 60;

  const minutes = String(Math.floor(diff / (1000 * 60))).padStart(2, "0");
  diff %= 1000 * 60;

  const seconds = String(Math.floor(diff / 1000)).padStart(2, "0");

  return { days, hours, minutes, seconds };
}

export const setIsTemporary = (value) => {
  localStorage.setItem("is_temporary", JSON.stringify(value));
};

export const getIsTemporary = () => {
  const item = localStorage.getItem("is_temporary");
  return item ? JSON.parse(item) : 0;
};

export const removeIsTemporary = () => {
  localStorage.removeItem("is_temporary");
};

export function toUTCISOStringFromDateTime(dateObj, timeObj) {
  if (!dateObj || !timeObj) return null;

  const date = new Date(dateObj);
  const time = new Date(timeObj);

  date.setHours(time.getHours());
  date.setMinutes(time.getMinutes());
  date.setSeconds(time.getSeconds());
  return date.toISOString();
}

export const formatAmount = (num) => {
  const parsedNum = parseFloat(num);
  if (isNaN(parsedNum)) return "";
  return parsedNum.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

export const formatAmountForDisplay = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const strValue = value.toString();
  // if (!/^\d*\.?\d{0,2}$/.test(strValue)) return "";

  if (strValue === ".") return "";

  if (strValue.endsWith(".")) return strValue;

  if (strValue.includes(".")) {
    return formatAmount(strValue);
  }

  return formatAmount(strValue);
};

// export const formatAmount = (num) => {
//   const parsedNum = parseFloat(num);

//   if (isNaN(parsedNum)) return "";

//   return parsedNum.toLocaleString("en-US", {
//     minimumFractionDigits: 0,
//     maximumFractionDigits: 2,
//   });
// };

// export const formatAmountForDisplay = (value) => {
//   if (value === null || value === undefined) return "";

//   const strValue = value.toString();

//   if (!/^\d*$/.test(strValue)) return "";
//   return formatAmount(strValue);
// };

export const formatFileFromUrl = (url, name, defaultLabel) => {
  if (!url) return [];

  const fullUrl = `${process.env.REACT_APP_ASSET_URL}/${url}`;

  if (url.toLowerCase().endsWith(".pdf")) {
    return [
      {
        name: name ? name : defaultLabel,
        url: PdfIcon,
        preview: true,
      },
    ];
  }

  return [
    {
      name: name ? name : defaultLabel,
      url: fullUrl,
      preview: true,
    },
  ];
};

export function extractFileName(originalPath) {
  if (!originalPath || typeof originalPath !== "string") return "";

  const sanitizedPath = originalPath.replace(/\\/g, "/");
  const fullFileName = sanitizedPath.split("/").pop();

  const extMatch = fullFileName.match(/\.[^/.]+$/);
  const extension = extMatch ? extMatch[0] : "";

  const nameWithoutExt = fullFileName.replace(/\.[^/.]+$/, "");
  const parts = nameWithoutExt.split("-");

  const nameParts = [];
  for (const part of parts) {
    if (/^\d{5,}$/.test(part) || /^[a-f0-9]{6,}$/i.test(part)) break;
    nameParts.push(part);
  }

  return nameParts.join("-").trim() + extension;
}

// export const toBase64 = async (url) => {
//   const response = await fetch(url, { mode: "no-cors" });
//   const blob = await response.blob();
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.onloadend = () => resolve(reader.result);
//     reader.onerror = reject;
//     reader.readAsDataURL(blob);
//   });
// };

export const toBase64 = async (url) => {
  const response = await fetch(url, {
    mode: "cors", // must allow CORS on your server
  });
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};
